module.exports = __webpack_public_path__ + "img/UFi-P012.22d84cc8.jpg";